<template>
  <div :class="['mainComm', { pendente }]">
    <div>
      <template v-if="pendente">
        <h4>Você tem pendências</h4>
        <p>Negocie Já!</p>
      </template>
      <template v-else-if="negociacao">
        <h4>Sua negociação</h4>
        <p>Você está em dia!</p>
      </template>
      <template v-else>
        <h4>Parabéns!</h4>
        <p>Você não tem negociações ativas nem parcelas em aberto, no momento.</p>
      </template>
    </div>
    <div>
      <p><b v-if="!pendente && negociacao">Próxima parcela em {{ negociacao.proximaParcela }} </b></p>
      <router-link v-if="pendente" :to="{name: 'negociejaApp', params: { session: 'negociar', step: 'debitos'}}" >Negociar</router-link>
      <router-link :to="{name: 'negociejaApp', params: { session: 'negociacao' }}"  @click.prevent="" v-else-if="negociacao">Ver</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pendencias: {
      type: Boolean,
      default: true
    },
    step: {
      type: String
    },
    negociacao: {
      type: Object,
    }
  },
  watch: {
    pendencias ( value ) {
      this.pendente = value
    }
  },
  data () {
    return {
      pendente: false,
      current: null
    }
  },
  mounted () {
    this.pendente = this.pendencias
  }
}
</script>

<style lang="scss">
  .mainComm {
    width: 100%;
    height: 120px;
    border-radius: $border-radius;
    background-color: $azul-escuro-2;
    box-shadow: -2px 3px 18px rgba(0,0,0,0.1);
    padding: $hmg_mid;
    display: flex; flex-direction: column;
    justify-content: space-between;

    
    >div {
      &:first-child {
        
      }

      &:last-child {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }

      p {
        margin: 0; padding: 0;
      }

      a {
        opacity: .6;
        font-weight: bold;
      }
    }

    &.pendente {
      background-color: $color-alert;

      >div { 
        a {
          opacity: 1
        }
      }
    }

  }
</style>